module.exports = function(app) {
	'use strict'
	app.directive('keywordsDir',keywordsDir);
	keywordsDir.$inject=['$http', '$timeout', '$rootScope','editorExludeShortcode'];
	function keywordsDir($http, $timeout, $rootScope,editorExludeShortcode) {
		return {
			restrict: 'E',
			scope:{
				parent:'=',
                keyWordsList:'=',
				content: '=',
				postTitle: '=',
				update: '='
			},  
			replace:true,
			template: require('./partial/keyword.html'),
			link: function(scope, ele, $attrs, ctrl) {

				scope.isCollapsed = false;
				scope.newKeyword = '';
				scope.manualKeyword = '';
				// watch for update keywords
				scope.$watch('update', function(newVal) {
					if (newVal) {
						scope.ensureMainKeyword();
						updateKeywordCounts();
					}
				});

				// Modify the content/title watch to only run if we have keywords
				scope.$watch(function() {
					return {
						content: scope.content || (scope.parent && scope.parent.tinymceModel),
						title: scope.postTitle || (scope.parent && scope.parent.dataPost.title)
					};
				}, function(newVal, oldVal) {
					if (scope.keyWordsList && scope.keyWordsList.length) {
						updateKeywordCounts();
					}
				}, true);

				// Add these to the top of link function
				scope.MAX_KEYWORDS = 10;
				scope.suggestionsError = '';
				scope.manualError = '';

				// Search Google Suggestions
				scope.searchGoogleSuggestions = function() {
					if (!scope.newKeyword) return;
					
					// Show error only if we're already at max when starting the search
					if (scope.keyWordsList.length >= scope.MAX_KEYWORDS) {
						scope.suggestionsError = 'Maximum number of keywords (' + scope.MAX_KEYWORDS + ') reached';
						scope.newKeyword = '';
						$timeout(function() {
							scope.suggestionsError = '';
						}, 3000);
						return;
					}
					
					var url = 'https://suggestqueries.google.com/complete/search';
					
					$http.jsonp(url, {
						params: {
							q: scope.newKeyword,
							client: 'chrome',
							hl: 'sr',
							jsonp: 'JSON_CALLBACK'
						}
					}).then(function(response) {
						if (response.data && Array.isArray(response.data[1])) {
							// Create array with searched keyword as first item
							var suggestions = [scope.newKeyword].concat(response.data[1]);
							
							// Add suggestions until we reach the limit
							suggestions.forEach(function(suggestion) {
								if (scope.keyWordsList.length < scope.MAX_KEYWORDS && !keywordExists(suggestion)) {
									scope.keyWordsList.push(createKeyword(suggestion, scope.keyWordsList.length === 0));
								}
							});
							
							scope.newKeyword = '';
							updateKeywordCounts();
						}
					}).catch(function(error) {
						alertService('danger','Opps! ', 'Error fetching suggestions:' + error);
					});
				};

				// This function checks for duplicates
				function keywordExists(keyword) {
					if (!keyword) return true; // Prevent empty keywords
					
					var normalizedNewKeyword = keyword.toLowerCase().trim();
					return scope.keyWordsList.some(function(item) {
						return item.name.toLowerCase().trim() === normalizedNewKeyword;
					});
				}

				// Add helper function to create keyword objects
				function createKeyword(name, isFirst) {
					return {
						name: name.trim().toLowerCase(),
						isMain: isFirst, // Will be main if it's the first keyword
						counts: {
							h1: 0,
							h2h3: 0,
							p: 0
						}
					};
				}

				// Add manual keyword
				scope.addManualKeyword = function() {
					// Clear manual error
					scope.manualError = '';

					// Check for max keywords first
					if (scope.keyWordsList.length >= scope.MAX_KEYWORDS) {
						scope.manualError = 'Maximum number of keywords (' + scope.MAX_KEYWORDS + ') reached';
						scope.manualKeyword = '';
						$timeout(function() {
							scope.manualError = '';
						}, 3000);
						return;
					}

					if (!scope.manualKeyword || keywordExists(scope.manualKeyword)) {
						if (scope.manualKeyword && keywordExists(scope.manualKeyword)) {
							scope.existKeyword = true;
							$timeout(function() {
								scope.existKeyword = false;
							}, 2000);
						}
						return;
					}
					
					scope.keyWordsList.push(createKeyword(scope.manualKeyword, scope.keyWordsList.length === 0));
					scope.manualKeyword = '';
					scope.existKeyword = false;
					updateKeywordCounts();
				};

				// Add this function to ensure one keyword is always main
				scope.ensureMainKeyword = function() {
					if (!scope.keyWordsList.length) return;
					
					// Check if there's any main keyword
					var hasMain = scope.keyWordsList.some(function(keyword) {
						return keyword.isMain;
					});
					
					// If no main keyword, set the first one as main
					if (!hasMain) {
						scope.keyWordsList[0].isMain = true;
					}
				};

				// Modify setMainKeyword to ensure we can't uncheck the last main keyword
				scope.setMainKeyword = function(selectedKeyword) {
					// Set all keywords to not main
					scope.keyWordsList.forEach(function(keyword) {
						keyword.isMain = false;
					});
					
					// Set the selected keyword as main
					selectedKeyword.isMain = true;
					updateKeywordCounts();
				};

				// Call ensureMainKeyword when loading keywords from backend
				scope.$watch('keyWordsList', function(newVal) {
					if (newVal && newVal.length) {
						scope.ensureMainKeyword();
					}
				}, true);

				// Modify removeKeyword to handle main keyword removal
				scope.removeKeyword = function(index) {
					var wasMain = scope.keyWordsList[index].isMain;
					scope.keyWordsList.splice(index, 1);
					
					// If we removed the main keyword and there are other keywords,
					// make the first remaining keyword main
					if (wasMain && scope.keyWordsList.length > 0) {
						scope.keyWordsList[0].isMain = true;
					}
					
					updateKeywordCounts();
				};

				// Cache the textarea element
				var textareaElement = document.createElement("textarea");
				// Normalize Serbian characters because we can got different encoding for same character (copy/paste from word, notepad, chrome, safari, etc.)
				function normalizeSerbian(text) {
					return text
						.replace(/\u0107/g, 'ć')  // ć variants -> ć
						.replace(/\u010D/g, 'č')  // č variants -> č
						.replace(/\u017E/g, 'ž')  // ž variants -> ž
						.replace(/\u0161/g, 'š')  // š variants -> š
						.replace(/\u00F0/g, 'đ')  // ð -> đ
						.replace(/\u0111/g, 'đ'); // đ -> đ
				}

				function countOccurrences(text, keyword) {
					if (!text || !keyword) return 0;
					
					// Decode HTML entities
					textareaElement.innerHTML = text;
					text = textareaElement.value;
					
					// Convert text to lowercase once at the beginning since keywords are already lowercase
					text = normalizeSerbian(text.toLowerCase());
					keyword = normalizeSerbian(keyword); // keyword is already lowercase from creation
					
					// Remove quotes and normalize spaces
					text = ' ' + text.replace(/["""'']/g, '')
						.replace(/\s+/g, ' ')
						.trim() + ' ';
					
					keyword = keyword.trim();
					
					// Create regex without 'i' flag since text is already lowercase
					var phraseRegex = new RegExp(
						'(?<=[\\s.,!?;:]|^)' + 
						keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') +
						'(?=[\\s.,!?;:]|$)', 
						'g'  // Removed 'i' flag since we don't need case-insensitive matching anymore
					);
					
					var matches = text.match(phraseRegex) || [];
					
					return matches.length;
				}

				// Update keyword counts with new bindings
				function updateKeywordCounts() {
					if (!Array.isArray(scope.keyWordsList)) {
						scope.keyWordsList = [];
						return;
					}

					var title = scope.postTitle || (scope.parent && scope.parent.dataPost.title) || '';
					var content = scope.content || (scope.parent && scope.parent.tinymceModel) || '';
					
					var div = document.createElement('div');
					div.innerHTML = editorExludeShortcode(content);
					
					// Get h2h3 text first
					var h2h3Elements = div.querySelectorAll('h2, h3');
					var h2h3Text = '';
					for (var i = 0; i < h2h3Elements.length; i++) {
						var text = h2h3Elements[i].textContent.trim();
						if (text) {
							h2h3Text += ' ' + text;
						}
					}
					h2h3Text = h2h3Text.trim();
					
					// Remove h2 and h3 elements
					var h2h3Tags = div.querySelectorAll('h2, h3');
					for (var i = 0; i < h2h3Tags.length; i++) {
						h2h3Tags[i].remove();
					}
					
					// Get remaining content and replace all HTML tags with spaces
					var pText = div.innerHTML
						.replace(/<\/?[^>]+(>|$)/g, ' ') // Replace any HTML tag with space
						.replace(/&nbsp;/g, ' ')         // Replace &nbsp; with space
						.replace(/\s+/g, ' ')            // Normalize multiple spaces
						.trim();
					// Update counts for each keyword
					scope.keyWordsList.forEach(function(keyword) {
						if (!keyword) return;
						
						keyword.counts = {
							h1: countOccurrences(title, keyword.name),
							h2h3: countOccurrences(h2h3Text, keyword.name),
							p: countOccurrences(pText, keyword.name)
						};
					});
				}

				// Add this helper function
				scope.isMainKeyword = function(keyword) {
					return keyword.isMain;
				};
				scope.clearAllKeywords = function() {
					scope.keyWordsList.length = 0;
				}
				// Add scope cleanup
				scope.$on('$destroy', function() {
					// Clear any timeouts or watchers if needed
					scope.keyWordsList = null;
				});
			}       
		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/keywords/keywordsDIrective.js
// module id = 441
// module chunks = 0